import { render } from "./ContentItem.vue?vue&type=template&id=4c64b7ab"
import script from "./ContentItem.vue?vue&type=script&lang=js"
export * from "./ContentItem.vue?vue&type=script&lang=js"

import "./ContentItem.vue?vue&type=style&index=0&id=4c64b7ab&lang=scss"

import exportComponent from "/builds/web-primary/web-ask-review/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__